var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayerRequired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFFAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9994 8.00059V10.0006M9.9994 12.0006H10.0044M9.1444 5.43059L4.9094 12.5006C4.82208 12.6518 4.77588 12.8232 4.77539 12.9979C4.77491 13.1725 4.82015 13.3442 4.90661 13.4959C4.99308 13.6476 5.11776 13.774 5.26825 13.8625C5.41875 13.9511 5.5898 13.9987 5.7644 14.0006H14.2344C14.409 13.9987 14.5801 13.9511 14.7305 13.8625C14.881 13.774 15.0057 13.6476 15.0922 13.4959C15.1787 13.3442 15.2239 13.1725 15.2234 12.9979C15.2229 12.8232 15.1767 12.6518 15.0894 12.5006L10.8544 5.43059C10.7653 5.28364 10.6398 5.16215 10.49 5.07783C10.3402 4.99351 10.1713 4.94922 9.9994 4.94922C9.82753 4.94922 9.65857 4.99351 9.5088 5.07783C9.35904 5.16215 9.23354 5.28364 9.1444 5.43059Z",
    stroke: "#F79009",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayerRequired);
export default __webpack_public_path__ + "static/media/payerRequired.1a8373362717c44b7d94448a4618804c.svg";
export { ForwardRef as ReactComponent };